import React from 'react';
import { Pagination } from 'react-bootstrap';

/**
 * Componente para la paginación de planillas
 */
const PlanillasPagination = ({ currentPage, totalPages, onPageChange }) => {
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Lógica para mostrar páginas con ellipsis
      if (currentPage <= 3) {
        // Principio: 1, 2, 3, 4, ..., totalPages
        pages.push(1, 2, 3, 4);
        if (totalPages > 4) pages.push('...', totalPages);
      } else if (currentPage >= totalPages - 2) {
        // Final: 1, ..., totalPages-3, totalPages-2, totalPages-1, totalPages
        pages.push(1, '...');
        for (let i = totalPages - 3; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Medio: 1, ..., currentPage-1, currentPage, currentPage+1, ..., totalPages
        pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
      }
    }

    return pages;
  };

  const pageNumbers = getPageNumbers();

  return (
    <div className="d-flex justify-content-center mt-4">
      <Pagination>
        {/* Primera página */}
        <Pagination.First
          disabled={currentPage === 1}
          onClick={() => onPageChange(1)}
        />

        {/* Anterior */}
        <Pagination.Prev
          disabled={currentPage === 1}
          onClick={() => onPageChange(currentPage - 1)}
        />

        {/* Números de página */}
        {pageNumbers.map((page, index) => (
          <React.Fragment key={index}>
            {page === '...' ? (
              <Pagination.Ellipsis disabled />
            ) : (
              <Pagination.Item
                active={page === currentPage}
                onClick={() => onPageChange(page)}
              >
                {page}
              </Pagination.Item>
            )}
          </React.Fragment>
        ))}

        {/* Siguiente */}
        <Pagination.Next
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        />

        {/* Última página */}
        <Pagination.Last
          disabled={currentPage === totalPages}
          onClick={() => onPageChange(totalPages)}
        />
      </Pagination>
    </div>
  );
};

export default PlanillasPagination;